import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http } from "../../lib/api";
import { Btn, Card } from "../../components/kit/Kit";
import { mxn, sel } from "../../components/captacion/common";
import { fDia } from "../../lib/trading";

const VACIO = { nombre: "", tipo: "PF", monto: "", plazo: "28 días", instruccion: "Sin dato", telefono: "" };

const Referir = ({ d, onDone }) => {
  const [f, setF] = useState(VACIO);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const plazos = [...new Set(d.tasas.flatMap((t) => Object.keys(t.tasas)))];
  const enviar = () => http.post("/portal/captacion/referir", { ...f, monto: Number(f.monto) }).then(() => { toast.success("Ahorrador referido"); setF(VACIO); onDone(); })
    .catch((e) => toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Revisa los datos"));
  return (
    <div className="grid grid-cols-2 gap-2 md:grid-cols-4" data-testid="pcap-referir">
      <input value={f.nombre} onChange={set("nombre")} placeholder="Nombre" className={`${sel} col-span-2`} data-testid="pcap-nombre" />
      <select value={f.tipo} onChange={set("tipo")} className={sel} data-testid="pcap-tipo">{["PF", "PFAE", "PM"].map((x) => <option key={x}>{x}</option>)}</select>
      <input type="number" value={f.monto} onChange={set("monto")} placeholder={`Monto (mín. ${mxn(f.tipo === "PM" ? d.minimos.PM : d.minimos.PF)})`} className={sel} data-testid="pcap-monto" />
      <select value={f.plazo} onChange={set("plazo")} className={sel} data-testid="pcap-plazo">{plazos.map((x) => <option key={x}>{x}</option>)}</select>
      <select value={f.instruccion} onChange={set("instruccion")} className={sel} data-testid="pcap-instruccion">{["Sin dato", "Reinvertir", "Liquidar"].map((x) => <option key={x}>{x}</option>)}</select>
      <input value={f.telefono} onChange={set("telefono")} placeholder="Teléfono" className={sel} data-testid="pcap-telefono" />
      <Btn onClick={enviar} data-testid="pcap-enviar">Referir</Btn>
    </div>
  );
};

const Tabla = ({ rows, cols, testid }) => (
  <div className="overflow-x-auto"><table className="w-full min-w-[420px] text-xs" data-testid={testid}>
    <thead><tr className="text-left text-[#8C867A]">{cols.map(([l]) => <th key={l} className="py-1">{l}</th>)}</tr></thead>
    <tbody>{rows.map((r, i) => <tr key={i} className="border-t border-[#F2F0EC]">{cols.map(([l, f]) => <td key={l} className="py-1">{f(r)}</td>)}</tr>)}</tbody>
  </table>{!rows.length && <p className="py-2 text-xs text-[#8C867A]">Sin registros</p>}</div>
);

export default function PortalCaptacion() {
  const [d, setD] = useState(null);
  const load = () => http.get("/portal/captacion").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  if (!d) return null;
  return (
    <div className="space-y-4" data-testid="portal-captacion">
      <Card title="Tasas vigentes (solo lectura)" testid="pcap-tasas">{d.tasas.map((t) => <p key={t.nombre} className="text-sm"><b>{t.nombre}</b> · {t.desde} → {t.hasta}<br />
        <span className="text-xs">{Object.entries(t.tasas).filter(([, v]) => v != null).map(([p, v]) => `${p}: ${v.toFixed(2)}%`).join(" · ")}</span></p>)}
        <p className="mt-1 text-[11px] text-[#8C867A]">Montos por inversión: PF/PFAE desde {mxn(d.minimos.PF)}, PM desde {mxn(d.minimos.PM)}, máximo {mxn(d.minimos.maximo)}. La tasa queda fija hasta el vencimiento.</p></Card>
      <Card title="Referir ahorrador"><Referir d={d} onDone={load} /></Card>
      <Card title={`Mi captación · ${d.ahorradores} ahorradores · ${mxn(d.saldo)}`} subtitle={`Corte ${fDia(d.corte, true)}`} testid="pcap-cartera">
        <Tabla testid="pcap-contratos" rows={d.contratos} cols={[["Ahorrador", (r) => r.ahorrador], ["Plazo", (r) => r.plazo], ["Saldo", (r) => mxn(r.saldo)], ["Tasa", (r) => (r.tasa == null ? "—" : `${r.tasa}%`)], ["Vence", (r) => r.vencimiento || "—"]]} /></Card>
      <Card title="Vencimientos próximos (60 días)" testid="pcap-vencimientos">
        <Tabla testid="pcap-venc-tabla" rows={d.vencimientos} cols={[["Ahorrador", (r) => r.ahorrador], ["Vence", (r) => r.vencimiento], ["Saldo", (r) => mxn(r.saldo)], ["Instrucción", (r) => r.instruccion]]} /></Card>
      <Card title="Mis referidos de captación" testid="pcap-oportunidades">
        <Tabla testid="pcap-op-tabla" rows={d.oportunidades} cols={[["Nombre", (r) => r.nombre], ["Monto", (r) => mxn(r.monto)], ["Plazo", (r) => r.plazo || "—"], ["Etapa", (r) => r.etapa]]} /></Card>
    </div>
  );
}
